import styled from 'styled-components';
import { BaseCard as CommonCard } from '@app/components/common/BaseCard/BaseCard';

export const Card = styled(CommonCard)`
  margin-bottom: 1rem;
  padding: 0rem;
`;
